export default "__VITE_ASSET__BWj1HQuO__"